// extracted by mini-css-extract-plugin
export default {"draggable":"DraggableCard_draggable__C8Xdz","dragging":"DraggableCard_dragging__aEodM","canceled":"DraggableCard_canceled__3MliL"};